import React, {useState} from 'react';
import {useSpring, animated} from 'react-spring';
import '../css/overlay.css';
import Button from './Button';


const Overlay = (props) => {
    const [show, setShow] = useState(false);
    const contentProps = useSpring({
          opacity: show ? 1 : 0,
          marginTop: show ? 0 : +1000,
      
      });
    let showit = function(){
        setShow(a => !a);
    }
    return (
            /* eslint-disable-next-line*/ 
            <a onClick={showit} className="tag"><Button name={props.btnname} sty="booking" />
            {!show ?
              (
                <div>
                </div>
              )
            : (
                <div className="overlay" onClick={showit}>
                  <animated.div className="overlay-container" style={contentProps} onClick={showit}>
                    <header>
                      <h3 className="overlay-title">Services</h3>
                      <h3 className="exit">X</h3>
                    </header>
                    <p>Natalie teaches one-on-one piano and theory lessons to students of any age and level in the comfort of their own homes. Tuition is individually adjusted to accommodate the student’s learning preferences and interests. </p>
                    <p>Natalie is well versed in an array of styles, including classical, pop, movie and game music. </p>
                    <h4>Rates:</h4>
                    <ul>
                      <li>30 min lesson = $35</li>
                      <li>45 min lesson = $52.50</li>
                      <li>60 min lesson = $70</li>
                    </ul>
                    <p className="note">Please note that lessons combining theory and piano tuition are required to be <strong>a minimum of 45minutes</strong>.</p>
                    <p>For more information, feel free to contact me</p>
                    <Button name="Contact Me" className="contact-but" id="#contact"/>
                  </animated.div>
                </div>
              )
          }</a>
    );
  };
  
  export default Overlay;